import RegularText from '@/components/RegularText';
import { WIDGET_POSITION_CHOICE } from '@/constants/enum';
import { handleSaveWidgetSettings, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { BlockStack, Box, Card, Icon, InlineStack, Select, TextField, Tooltip } from '@shopify/polaris';
import { ProductListIcon } from '@shopify/polaris-icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

export const WidgetProductPageCard = () => {
  const { t } = useTranslation('widget_settings');
  const widgetSettings = useSelector(widgetSettingSelector);
  const dispatch = useDispatch();

  const widgetProductPageOptions = useMemo(
    () => [
      {
        label: t('position.selector.productPage.options.0'),
        value: WIDGET_POSITION_CHOICE.BEFORE_BEGIN,
      },
      {
        label: t('position.selector.productPage.options.1'),
        value: WIDGET_POSITION_CHOICE.AFTER_BEGIN,
      },
      {
        label: t('position.selector.productPage.options.2'),
        value: WIDGET_POSITION_CHOICE.BEFORE_END,
      },
      {
        label: t('position.selector.productPage.options.3'),
        value: WIDGET_POSITION_CHOICE.AFTER_END,
      },
    ],
    [t],
  );

  return (
    <Card padding={'300'}>
      <BlockStack gap={'300'}>
        <InlineStack gap={'100'}>
          <Box>
            <Icon source={ProductListIcon} />
          </Box>
          <RegularText fontWeight="medium">{t('position.selector.productPage.title')}</RegularText>
        </InlineStack>
        <TextField
          label={
            <Tooltip content={t('position.selector.productPage.tooltip')}>
              <RegularText>{t('position.selector.productPage.cssLabel')}</RegularText>
            </Tooltip>
          }
          helpText={t('position.selector.productPage.cssHelpText')}
          autoComplete="off"
          onChange={(value) => {
            dispatch(
              handleSaveWidgetSettings({
                widgetPosition: {
                  ...widgetSettings.widgetPosition,
                  productPageSelector: value,
                },
              }),
            );
          }}
          value={widgetSettings.widgetPosition.productPageSelector}
        />
        <Select
          label={t('position.selector.productPage.positionLabel')}
          onChange={(value) =>
            dispatch(
              handleSaveWidgetSettings({
                widgetPosition: {
                  ...widgetSettings.widgetPosition,
                  productPagePosition: value,
                },
              }),
            )
          }
          options={widgetProductPageOptions}
          value={widgetSettings.widgetPosition.productPagePosition}
        />
      </BlockStack>
    </Card>
  );
};
